import { render, staticRenderFns } from "./GroupRequestDetail.vue?vue&type=template&id=991fae56&"
import script from "./GroupRequestDetail.vue?vue&type=script&lang=js&"
export * from "./GroupRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupRequestDetail.vue?vue&type=style&index=0&id=991fae56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports